type Skill = {
  title: string
  brand: string
}

function Brands() {
  const skills: Skill[] = [
    {
      title: 'Azure',
      brand: 'images/brands/azure.png',
    },
    {
      title: 'Reactjs',
      brand: 'images/brands/reactjs.png',
    },
    {
      title: 'Styled Components',
      brand: 'images/brands/styled-components.png',
    },
    {
      title: 'TypeScript',
      brand: 'images/brands/ts.jpg',
    },
    {
      title: 'React Context Hook',
      brand: 'images/brands/react-context.png',
    },
    {
      title: 'Angular',
      brand: 'images/brands/angular.png',
    },
    {
      title: 'Vue',
      brand: 'images/brands/vue.png',
    },
    {
      title: 'Vuestrap',
      brand: 'images/brands/vuestrap.png',
    },
    {
      title: 'JavaScript',
      brand: 'images/brands/javascript.jpg',
    },
    {
      title: 'HTML5',
      brand: 'images/brands/HTML5.jpg',
    },
    {
      title: 'css3',
      brand: 'images/brands/css3.jpg',
    },
    {
      title: 'Less',
      brand: 'images/brands/less.jpg',
    },
    {
      title: 'Sass',
      brand: 'images/brands/sass.jpg',
    },
    {
      title: 'Git',
      brand: 'images/brands/git.jpg',
    },
    {
      title: 'Yarn',
      brand: 'images/brands/yarn.png',
    },
    {
      title: 'NPM',
      brand: 'images/brands/npm.jpg',
    },
    {
      title: 'Nodejs',
      brand: 'images/brands/nodejs.jpg',
    },
    {
      title: 'Bootstrap',
      brand: 'images/brands/bootstrap.png',
    },
    {
      title: 'Wordpress',
      brand: 'images/brands/wordpress.jpg',
    },
    {
      title: 'Gulp',
      brand: 'images/brands/gulp.jpg',
    },
    {
      title: 'Grunt',
      brand: 'images/brands/grunt.jpg',
    },
    {
      title: 'Bower',
      brand: 'images/brands/bower.jpg',
    },
    {
      title: 'Photoshop',
      brand: 'images/brands/photoshop-cc.jpg',
    },
    {
      title: 'XD',
      brand: 'images/brands/xd.jpg',
    },
    {
      title: 'Figma',
      brand: 'images/brands/figma.png',
    },
  ]

  return (
    <section className="brands m5-4">
      <h4 className="brands-title">Habilidades</h4>
      <div>
        {skills.map((skill, index) => (
          <img
            key={index}
            src={skill.brand}
            className="mx-1 my-2"
            alt={skill.title}
          />
        ))}
      </div>
    </section>
  )
}

export default Brands
